import React from "react";
import { Row, Col, Breadcrumb, Table, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation/Navigation";
import Footer from "./Footer/Footer";
import { Redirect } from "react-router";
import firebase from "../Utils/Firebase";
import User from "../model/User";

class Referrals extends React.Component {
  state = {
    sideMenu: true,
    loading: true,
    redirect: false,
  };

  _onSideMenu = (active) => {
    this.setState({ sideMenu: active });
  };

  async componentDidMount() {
    let App = this;
    firebase
      .firestore()
      .collection("referrals")
      .get()
      .then((snapshot) => {
        let documents = snapshot.docs;
        documents.forEach((doc, i) => {
          let row = document.createElement("tr");
          row.onclick = function() {
            User.getInstance().selectedReferralId = doc.ref.path.split("/")[1];
            User.getInstance().selectedReferral = doc.data();
            App.setState({ redirect: true });
          };
          let index = document.createElement("td");
          index.className = "text-center";
          index.innerText = i + 1;
          let senderName = document.createElement("td");
          senderName.className = "text-center";
          senderName.innerText = doc.data().senderName;
          let uid = document.createElement("td");
          uid.className = "text-center";
          uid.innerText = doc.data().uid;
          let shopName = document.createElement("td");
          shopName.className = "text-center";
          shopName.innerText = doc.data().shopName;
          let shopAddress = document.createElement("td");
          shopAddress.className = "text-center";
          shopAddress.innerText = doc.data().shopAddress;
          let barberName = document.createElement("td");
          barberName.className = "text-center";
          barberName.innerText = doc.data().barberName;
          let barberNumber = document.createElement("td");
          barberNumber.className = "text-center";
          barberNumber.innerText = doc.data().barberNumber;
          let status = document.createElement("td");
          status.className = "text-center";
          status.innerText = doc.data().status;

          row.appendChild(index);
          row.appendChild(senderName);
          row.appendChild(uid);
          row.appendChild(shopName);
          row.appendChild(shopAddress);
          row.appendChild(barberName);
          row.appendChild(barberNumber);
          row.appendChild(status);

          document.getElementById("tbody").appendChild(row);
        });
      });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect push to="/referral" />;
    }
    return (
      <div className="page-wrapper">
        <Navigation onClick={this._onSideMenu} />

        <div
          className={`main-content d-flex flex-column ${
            this.state.sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <Breadcrumb>
              <h1>Referrals</h1>
              <Link to="/dashboard" className="breadcrumb-item">
                Users
              </Link>
              <Breadcrumb.Item active>Referrals</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <Row>
            <Col xl={12}>
              <div className="card mb-4">
                <div className="card-body">
                  <div className="card-header">
                    <h5 className="card-title">List of Referrals</h5>
                  </div>

                  <Table id="myTable" responsive hover striped className="m-0">
                    <thead>
                      <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">Sender Name</th>
                        <th className="text-center">Sender User Id</th>
                        <th className="text-center">Shop Name</th>
                        <th className="text-center">Shop Address</th>
                        <th className="text-center">Barber Name</th>
                        <th className="text-center">Barber Number</th>
                        <th className="text-center">Status</th>
                      </tr>
                    </thead>
                    <tbody id="tbody" />
                  </Table>
                </div>
              </div>
            </Col>
          </Row>

          <div className="flex-grow-1" />
          <Footer />
        </div>
      </div>
    );
  }
}

export default Referrals;
